'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getGatewayFieldDisplayName = exports.getGatewayDisplayName = exports.getGatewayById = exports.getGatewaysForCountry = exports.gateways = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _net = require('./gateways/net.authorize');

var _net2 = _interopRequireDefault(_net);

var _com = require('./gateways/com.braintreegateway');

var _com2 = _interopRequireDefault(_com);

var _ilCo = require('./gateways/il.co.creditguard');

var _ilCo2 = _interopRequireDefault(_ilCo);

var _com3 = require('./gateways/com.ewaypayments');

var _com4 = _interopRequireDefault(_com3);

var _auCom = require('./gateways/au.com.fatzebra');

var _auCom2 = _interopRequireDefault(_auCom);

var _com5 = require('./gateways/com.mercurypay');

var _com6 = _interopRequireDefault(_com5);

var _com7 = require('./gateways/com.paguelofacil');

var _com8 = _interopRequireDefault(_com7);

var _com9 = require('./gateways/com.paybox');

var _com10 = _interopRequireDefault(_com9);

var _com11 = require('./gateways/com.paymentexpress');

var _com12 = _interopRequireDefault(_com11);

var _com13 = require('./gateways/com.pelecard');

var _com14 = _interopRequireDefault(_com13);

var _com15 = require('./gateways/com.stripe');

var _com16 = _interopRequireDefault(_com15);

var _com17 = require('./gateways/com.tranzila');

var _com18 = _interopRequireDefault(_com17);

var _comWorldpay = require('./gateways/com.worldpay.enterprise');

var _comWorldpay2 = _interopRequireDefault(_comWorldpay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Gateways

// // import mercadopago from './gateways/com.mercadopago';
var gatewaysList = [_net2.default, _com2.default, _ilCo2.default, _com4.default, _auCom2.default,
// mercadopago,
_com6.default, _com8.default, _com10.default, _com12.default, _com14.default, _com16.default, _com18.default, _comWorldpay2.default];

var gateways = exports.gateways = _lodash2.default.reduce(gatewaysList, function (gateways, gateway) {
    gateways[gateway.id] = gateway;return gateways;
}, {});

var getGatewaysForCountry = exports.getGatewaysForCountry = function getGatewaysForCountry(countryCode) {
    return (0, _lodash2.default)(gateways).filter(function (gateway) {
        return _lodash2.default.includes(gateway.countries, countryCode);
    }).orderBy('ranking', 'desc').map(function (gateway) {
        return _lodash2.default.omit(gateway, 'countries', 'ranking');
    }).value();
};

var getGatewayById = exports.getGatewayById = function getGatewayById(gatewayId) {
    return _lodash2.default.find(gateways, { 'id': gatewayId });
};

var getGatewayDisplayName = exports.getGatewayDisplayName = function getGatewayDisplayName(i18nGet, gatewayId) {
    return i18nGet('gateway_' + gatewayId + '_title');
};
var getGatewayFieldDisplayName = exports.getGatewayFieldDisplayName = function getGatewayFieldDisplayName(i18nGet, gatewayId, field) {
    return i18nGet('gateway_' + gatewayId + '_field_' + field);
};